if (!customElements.get('promotional-badges')) {
    class PromotionalBadges extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.sectionId = this.dataset.sectionId;
            this.promoDataScript = document.getElementById(`PromotionalBadgesData-${this.sectionId}`);

            this.initPopup();

            if (!this.promoDataScript) return;

            try {
                this.variantData = JSON.parse(this.promoDataScript.textContent);
            } catch (e) {
                console.error('Error parsing promotional badges data', e);
                return;
            }

            // Subscribe to variant changes from product-info or other sources 
            // Assuming 'variant:change' pubsub event or we can listen to URL changes/custom events
            // The theme seems to use a PUB_SUB system based on product-info.js

            // Try to hook into the existing PUB_SUB if available globally
            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                this.subscription = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
            } else if (window.subscribe && window.PUB_SUB_EVENTS) {
                // Fallback if they are somehow on window
                this.subscription = window.subscribe(window.PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
            } else {
                console.warn('PromotionalBadges: subscribe or PUB_SUB_EVENTS not found');
            }
        }

        disconnectedCallback() {
            if (this.subscription) {
                // Assuming subscription returns an unsubscribe function
                if (typeof this.subscription === 'function') this.subscription();
            }
            if (this.handleDocumentClick) {
                document.removeEventListener('click', this.handleDocumentClick);
            }
        }

        initPopup() {
            const trigger = this.querySelector('.promotional-lowest-price');
            const popup = this.querySelector('.lowest-price-popup');
            const closeBtn = this.querySelector('.popup-close');

            if (!trigger || !popup) return;

            trigger.addEventListener('click', (e) => {
                if (e.target.closest('.lowest-price-popup') && !e.target.closest('.popup-close')) {
                    return;
                }
                popup.classList.toggle('active');
            });

            if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    popup.classList.remove('active');
                });
            }

            this.handleDocumentClick = (e) => {
                if (!trigger.contains(e.target)) {
                    popup.classList.remove('active');
                }
            };
            document.addEventListener('click', this.handleDocumentClick);
        }

        onVariantChange(event) {
            if (event.data.sectionId !== this.sectionId) return;
            const variantId = event.data.variant.id;
            this.updateBadges(variantId);
        }

        updateBadges(variantId) {
            const data = this.variantData[variantId];
            if (!data) return;

            const percentOffBadge = this.querySelector('.promo-badge--percent-off');
            const saveAmountBadge = this.querySelector('.promo-badge--save-amount');
            const percentText = this.querySelector('.js-percent-off');
            const saveText = this.querySelector('.js-save-amount');

            if (data.compare_at_price > data.price) {
                // Show badges
                if (percentOffBadge) {
                    percentOffBadge.style.display = '';
                    if (percentText) percentText.textContent = `${data.percent_off}% OFF`;
                }
                if (saveAmountBadge) {
                    saveAmountBadge.style.display = '';
                    if (saveText) saveText.textContent = `SAVE ${data.save_amount_money}`;
                }
            } else {
                // Hide badges
                if (percentOffBadge) percentOffBadge.style.display = 'none';
                if (saveAmountBadge) saveAmountBadge.style.display = 'none';
            }
        }
    }

    customElements.define('promotional-badges', PromotionalBadges);
}
